import { ValidationContext } from "sanity";
import { SUPPORTED_LANGUAGES } from "./localization";

const contentIsPresent = (value: string | undefined): value is string =>
  !!value && value.trim() != "";

const someLanguageDefined = (context: ValidationContext) =>
  SUPPORTED_LANGUAGES.some((lang) =>
    contentIsPresent((context.parent as any)[lang.id])
  );

export const someLanguageShouldBeProvided = (
  item: unknown,
  context: ValidationContext
) => {
  const atLeastOneLang = someLanguageDefined(context);
  return atLeastOneLang || "At least one language should be provided";
};

export const validateMultilingualUrl = (value: string | undefined) => {
  if (!value || value.trim() === "") {
    return true;
  }

  const trimmedUrl = value.trim();

  const hasInvalidChars = /[^a-zA-Z0-9\-._~:/?#\[\]@!$&'()*+,;=%]/.test(
    trimmedUrl
  );
  if (hasInvalidChars) {
    return `"${trimmedUrl}" contains invalid characters. URLs should only contain alphanumeric characters and these symbols: -._~:/?#[]@!$&'()*+,;=%`;
  }

  const isRelative = /^\/[^\s]*$/.test(trimmedUrl);
  const isAbsolute = /^https?:\/\/[^/?#]+\.[^/?#]+/.test(trimmedUrl);
  const isMailTo = /^mailto:[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedUrl);


  if (!isRelative && !isAbsolute && !isMailTo) {
    return `"${trimmedUrl}" is not a valid URL. Use relative URLs (e.g., /path/file.html) or absolute URLs with complete host (e.g., https://www.google.it/path)`;
  }

  return true;
};
